import type { ComponentStyleConfig } from "@chakra-ui/react";

export const BadgeTheme: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "body",
  },
  variants: {
    brand: {
      textTransform: "capitalize",
      bg: "brand.red.100",
      py: 1,
      px: 2,
      color: "white",
      fontWeight: 500,
      borderRadius: 4,
    },
  },
};
